import { render } from "./PlaylistsPanel.vue?vue&type=template&id=ea7fa80e"
import script from "./PlaylistsPanel.vue?vue&type=script&lang=js"
export * from "./PlaylistsPanel.vue?vue&type=script&lang=js"

import "./PlaylistsPanel.vue?vue&type=style&index=0&id=ea7fa80e&lang=sass"

import exportComponent from "/creek/ws/studio-website-elements/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__